import cookie from 'react-cookie';
import ClientSideUrls from './client-side-urls';
import config from '../config';
import moment from 'moment';

const nativeAuthTokenKey = 'nativeAuthToken';
const sharedAuthTokenKey = 'sharedSearchAssociatesAuthToken';

export function setNativeToken(value) {
  return setCookie(nativeAuthTokenKey, value);
}

export function getNativeToken() {
  return getCookie(nativeAuthTokenKey);
}

export function clearNativeToken() {
  removeCookie(nativeAuthTokenKey);
}

export function keepNativeToken() {
  keepCookie(nativeAuthTokenKey);
}

export function setSharedToken(value) {
  return setCookie(sharedAuthTokenKey, value);
}

export function getSharedToken() {
  return getCookie(sharedAuthTokenKey);
}

export function clearSharedToken() {
  removeCookie(sharedAuthTokenKey);
}

export function keepSharedToken() {
  keepCookie(sharedAuthTokenKey);
}

function generateCookieExpireDate() {
  return moment()
    .add(getCookieMaxAgeInMilliseconds(), 'millisecond')
    .toDate();
}

function getCookieMaxAgeInMilliseconds() {
  const { idleMonitor: { expiredDelay, awayDelay, inactiveDelay } } = config;

  const tokenTtlInMilliseconds = awayDelay + inactiveDelay + expiredDelay;

  return tokenTtlInMilliseconds;
}

function keepCookie(key) {
  const value = getCookie(key);

  if (value) {
    setCookie(key, value);
  }
}

function getCookie(key) {
  return cookie.load(key);
}

function removeCookie(key) {
  const clientRootPath = ClientSideUrls.getClientRootPath();
  cookie.remove(key, { path: clientRootPath });
}

function setCookie(key, value) {
  let ensuredValue = typeof value === undefined || value === null ? '' : value;

  const clientRootPath = ClientSideUrls.getClientRootPath();

  const dateExpires = generateCookieExpireDate();

  cookie.save(key, ensuredValue, {
    path: clientRootPath,
    expires: dateExpires
  });

  return dateExpires;
}



// WEBPACK FOOTER //
// ./src/tools/token-storage.js